<template>
  <div class="page" v-editable="blok">
    <component :key="blok._uid" v-for="blok in blok.body" :blok="blok" :is="blok.component"></component>
  </div>
</template>

<script>
export default {
  props: ['blok']
}
</script>



// WEBPACK FOOTER //
// src/components/Page.vue